import { Button, Tooltip  } from 'reactstrap';
import { useState, useId } from "react";
import { useTheme } from '../hooks/useTheme';
import { downloadCSV } from "../utils/fileUtils";

const Download = ({data, fileName, showIcon = false, alternativeQueryFunction, text = "Download", showTooltip = false, buttonIsEnabled = true }) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const theme = useTheme()
    const id = `download_${useId().replace(/:/g, "")}`;

    const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

    const downloadFile = async () => {
      let finalData = data;
      if (alternativeQueryFunction) {
        const query = await alternativeQueryFunction(); // gets data from an alternative function pointer rather than the 'data' prop
        finalData = [...query]
      }

      downloadCSV(finalData, fileName);
  }
  return (
    <>
      <Button id={id} data-testid="download-button" className="btn-icon btn-md cursor-pointer"
      onClick={downloadFile} disabled={!buttonIsEnabled}>{showIcon ? <i className="bi bi-download"></i> :<span>{text}</span>}</Button>
      {showTooltip && <Tooltip
          placement="top"
          isOpen={tooltipOpen}
          target={id}
          toggle={toggleTooltip}>Export to CSV
        </Tooltip>
      }
    </>
  )
}

export default Download
